import React from "react";
import ExportButton from "./ExportButton";

const MobileFilter = ({
  title = "History",
  exportDisabled = false,
  onExport = null,
  children,
}) => {
  return (
    <>
      <div className="d-block d-md-none mb-4 mt-2">
        <div className="d-flex justify-content-between align-items-center">
          {/* <h5 className="mb-0 fw-bold font-size-16 text-dark">Overview</h5> */}
          <div className="d-flex gap-2 w-100">
            {onExport && (
              <ExportButton
                disabled={exportDisabled}
                onClick={onExport}
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: "100%",
                  height: "36px",
                  borderRadius: "6px",
                  fontSize: "13px",
                  padding: "0",
                }}
              />
            )}
            <button
              className="btn btn-primary d-flex align-items-center justify-content-center"
              style={{
                width: "100%",
                height: "36px",
                borderRadius: "6px",
                fontSize: "13px",
                padding: "0",
              }}
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#filterOffcanvasMobile"
            >
              <i className="mdi mdi-filter-variant fs-5 me-1"></i> Filter
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Bottom Sheet Offcanvas */}
      <div
        className="offcanvas offcanvas-bottom"
        tabIndex="-1"
        id="filterOffcanvasMobile"
        aria-labelledby="filterOffcanvasMobileLabel"
        style={{
          height: "auto",
          maxHeight: "90vh",
          borderRadius: "24px 24px 0 0",
          boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div className="offcanvas-header border-bottom px-4 py-3">
          <h5 className="offcanvas-title fw-bold" id="filterOffcanvasMobileLabel">
            Filters
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            data-bs-target="#filterOffcanvasMobile"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body p-4">
          <div className="d-flex flex-column gap-3 w-100">{children}</div>
        </div>
      </div>
    </>
  );
};

export default MobileFilter;
